import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * Read-only view of a question asked by the agent, shown in chat history.
 */
export function UserQuestionReadOnly({ question }) {
  const { t } = useTranslation();
  const { question_text, options, multi_select } = question;

  return (
    <div className="flex gap-2 mt-2">
      <Icon icon="mdi:help-circle-outline" className="size-4 text-gray-400 mt-0.5 flex-shrink-0" />
      <div>
        <p className="text-xs text-gray-500 font-medium">{question_text}</p>
        <div className="flex flex-wrap gap-1 mt-1">
          {options.map((option, index) => (
            <span
              key={index}
              className="inline-flex items-center px-2 py-0.5 text-xs text-gray-500 bg-gray-100 rounded-full"
            >
              {option.label}
            </span>
          ))}
          {multi_select && (
            <span className="inline-flex items-center px-2 py-0.5 text-xs text-gray-400 italic">
              {t('ai.userQuestion.multiSelect')}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

UserQuestionReadOnly.propTypes = {
  question: PropTypes.shape({
    question_text: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        description: PropTypes.string,
      }),
    ).isRequired,
    multi_select: PropTypes.bool,
  }).isRequired,
};
